import { Playlist } from '@bpm-web-app/download-api-sdk';
import { appendQueryParams, formatDateToString } from '@bpm-web-app/utils';
import Card from '../card';
import CardGhostLoading from '../card-ghost-loading';

interface PlaylistCardProps {
    playlists?: Playlist[];
    playlist?: Playlist;
    isGhost?: boolean;
    className?: string;
    /* Shows the last-updated date instead of the artist list — for contexts (e.g. Your Feed)
     * where recency matters more than which artists are on the playlist. */
    showUpdatedDate?: boolean;
}

export function PlaylistCard({ playlist, playlists, isGhost, className, showUpdatedDate }: PlaylistCardProps) {
    if (isGhost) {
        return (
            <CardGhostLoading contentType="exclusive-playlist" />
        );
    }

    /* formatDateToString returns '' for a missing date — don't render a dangling "Updated ". */
    const formattedUpdatedAt = formatDateToString(playlist?.updated_at, 'MM/DD/YYYY');

    return playlist ? (
        <Card
            cardSize="small"
            contentType="exclusive-playlist"
            id={playlist.id}
            title={playlist.title}
            imageUrl={appendQueryParams(playlist.image_url, { key: 'dw', value: 160 })}
            imageUrl2x={appendQueryParams(playlist.image_url, { key: 'dw', value: 320 })}
            isPlayable
            {...(showUpdatedDate
                ? { description: formattedUpdatedAt ? `Updated ${formattedUpdatedAt}` : '', isDescriptionSingleLine: true }
                : { descriptionProps: { artist: playlist.artist, artists: playlist.artists } })}
            link={`exclusive-playlist/${playlist.id}`}
            badge={playlist?.badge}
            currentPlaylist={playlists}
            className={className}
        />
    ) : null;
}
